"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _of = require("rxjs/observable/of");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _reduxObservable = require("redux-observable");

var _interactionsSelectors = require("../selectors/interactionsSelectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _SaveActions = require("../actions/SaveActions");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var saveDefaultContactProperties = function saveDefaultContactProperties($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_SaveActions.SaveActionTypes.SAVE_DEFAULT_CONTACT_PROPERTY_VALUES).pipe((0, _filter.filter)(function () {
    return (0, _selectors.getSaveSiteSettingsChangesRequestStatus)(getState()) !== _RequestStatusTypes.default.PENDING;
  }), (0, _mergeMap.mergeMap)(function () {
    var stagedDefaultContactPropertyValues = (0, _interactionsSelectors.getStagedDefaultContactPropertyValues)(getState());
    var relevantPropertyValues = stagedDefaultContactPropertyValues.get(_UrlPathParams.ALL_DOMAINS);
    return (0, _of.of)((0, _actions.saveStagedSiteSettingsMergeTagsChanges)((0, _defineProperty2.default)({}, _constants.MERGE_TAG_DEFAULTS, relevantPropertyValues), {
      selectedDomain: _UrlPathParams.ALL_DOMAINS
    }));
  }));
};

var saveDefaultCompanyProperties = function saveDefaultCompanyProperties($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_SaveActions.SaveActionTypes.SAVE_DEFAULT_COMPANY_PROPERTY_VALUES).pipe((0, _filter.filter)(function () {
    return (0, _selectors.getSaveSiteSettingsChangesRequestStatus)(getState()) !== _RequestStatusTypes.default.PENDING;
  }), (0, _mergeMap.mergeMap)(function () {
    var stagedDefaultCompanyPropertyValues = (0, _interactionsSelectors.getStagedDefaultCompanyPropertyValues)(getState());
    var relevantPropertyValues = stagedDefaultCompanyPropertyValues.get(_UrlPathParams.ALL_DOMAINS);
    return (0, _of.of)((0, _actions.saveStagedSiteSettingsMergeTagsChanges)((0, _defineProperty2.default)({}, _constants.ACCOUNT_MERGE_TAG_DEFAULTS, relevantPropertyValues), {
      selectedDomain: _UrlPathParams.ALL_DOMAINS
    }));
  }));
};

var saveDefaultOwnerProperties = function saveDefaultOwnerProperties($action, _ref3) {
  var getState = _ref3.getState;
  return $action.ofType(_SaveActions.SaveActionTypes.SAVE_DEFAULT_OWNER_PROPERTY_VALUES).pipe((0, _filter.filter)(function () {
    return (0, _selectors.getSaveSiteSettingsChangesRequestStatus)(getState()) !== _RequestStatusTypes.default.PENDING;
  }), (0, _mergeMap.mergeMap)(function () {
    var stagedDefaultOwnerPropertyValues = (0, _interactionsSelectors.getStagedDefaultOwnerPropertyValues)(getState());
    var relevantPropertyValues = stagedDefaultOwnerPropertyValues.get(_UrlPathParams.ALL_DOMAINS);
    return (0, _of.of)((0, _actions.saveStagedSiteSettingsMergeTagsChanges)((0, _defineProperty2.default)({}, _constants.OWNER_MERGE_TAG_DEFAULTS, relevantPropertyValues), {
      selectedDomain: _UrlPathParams.ALL_DOMAINS
    }));
  }));
};

var _default = (0, _reduxObservable.combineEpics)(saveDefaultContactProperties, saveDefaultCompanyProperties, saveDefaultOwnerProperties);

exports.default = _default;
module.exports = exports.default;